// extracted by mini-css-extract-plugin
export default {"banner":"CookieBanner_banner__frteI","acceptButton":"CookieBanner_acceptButton__WdK2v","declineButton":"CookieBanner_declineButton__me+rd"};